<template>
	<div>
	<h1 class="mb-4">{{ title }}</h1>
		<v-filters
			class="mb-4"
			v-bind="{
				filters: urlFilters,
				clientsTariffs: CLIENTS_TARIFFS,
				loading
			}"
			@update-filters="updateUrl"
		/>
		<v-btn
			@click="downloadCsv"
		>
			Экспорт CSV
		</v-btn>
		<v-data-table
			class="projects-statistics-table"
			:headers="headers"
			:items="tableItems"
			:loading="loading.table"
			disable-pagination
			hide-default-footer
			fixed-header
			height="calc(100vh - 225px)"
		>
			<template v-slot:item.avg_semantic_cnt="{ item }">
				{{ formatFloat(item.avg_semantic_cnt) }}
			</template>
			<template v-slot:header.created_date="{ header }">
				<div class="d-flex align-center justify-center">
					<span>{{ header.text }}</span>

					<v-tooltip bottom>
						<template v-slot:activator="{ on, attrs }">
							<v-icon
								small
								class="ml-1"
								v-bind="attrs"
								v-on="on"
							>
								mdi-information-outline
							</v-icon>
						</template>

						<span>
          Дата создания проекта
        </span>
					</v-tooltip>
				</div>
			</template>
			<template v-slot:header.send_days_yandex_cnt="{ header }">
				<div class="d-flex align-center justify-center">
					<span>{{ header.text }}</span>

					<v-tooltip bottom>
						<template v-slot:activator="{ on, attrs }">
							<v-icon
								small
								class="ml-1"
								v-bind="attrs"
								v-on="on"
							>
								mdi-information-outline
							</v-icon>
						</template>

						<span>
          Кол-во дней сбора яндекс
        </span>
					</v-tooltip>
				</div>
			</template>
			<template v-slot:header.send_days_google_cnt="{ header }">
				<div class="d-flex align-center justify-center">
					<span>{{ header.text }}</span>

					<v-tooltip bottom>
						<template v-slot:activator="{ on, attrs }">
							<v-icon
								small
								class="ml-1"
								v-bind="attrs"
								v-on="on"
							>
								mdi-information-outline
							</v-icon>
						</template>

						<span>
          Кол-во дней сбора гугл
        </span>
					</v-tooltip>
				</div>
			</template>
			<template v-slot:header.send_all_data="{ header }">
				<div class="d-flex align-center justify-center">
					<span>{{ header.text }}</span>

					<v-tooltip bottom>
						<template v-slot:activator="{ on, attrs }">
							<v-icon
								small
								class="ml-1"
								v-bind="attrs"
								v-on="on"
							>
								mdi-information-outline
							</v-icon>
						</template>

						<span>
          Отправленные unit
        </span>
					</v-tooltip>
				</div>
			</template>
			<template v-slot:header.receipt_all_data="{ header }">
				<div class="d-flex align-center justify-center">
					<span>{{ header.text }}</span>

					<v-tooltip bottom>
						<template v-slot:activator="{ on, attrs }">
							<v-icon
								small
								class="ml-1"
								v-bind="attrs"
								v-on="on"
							>
								mdi-information-outline
							</v-icon>
						</template>

						<span>
          Полученные unit
        </span>
					</v-tooltip>
				</div>
			</template>
		</v-data-table>
	</div>
</template>

<script>
import { mapActions, mapState } from 'vuex'
import filters from './filters.vue'
import { validateFilterFromOptions } from '@/function/validateFilter'
import updateUrlMixin from '@/mixins/updateUrlMixin'
import { NOTIFY_STATUS } from '@/const'
import errors from '@/store/errors'

const CLIENTS_TARIFFS = [
	{ text: 'Не выбран', value: 0 },
	{ text: 'Base', value: 1 },
	{ text: 'Pro', value: 2 },
	{ text: 'Premium', value: 3 },
	{ text: 'Специальный', value: 4 },
	{ text: 'Enterprise', value: 5 },
	{ text: 'Demo', value: 6 },
	{ text: 'Position', value: 7 },
	{ text: 'Position Plus', value: 8 }
]

export default {
	name: 'projectsStatistics',
	components: {
		'v-filters': filters
	},
	mixins: [updateUrlMixin],

	metaInfo () {
		return {
			title: this.title
		}
	},

	data () {
		return {
			title: 'Проектные лимиты',
			CLIENTS_TARIFFS,
			monthMenu: false,
			selectedMonth: null,
			clientSearch: '',
			filters: {
				only_active_projects: 1
			},
			showInactive: false,
			headers: [
				{
					text: 'ID проекта',
					value: 'project_id',
					align: 'center',
					divider: true
				},
				{
					text: 'project_description',
					value: 'project_description',
					align: 'center',
					divider: true
				},
				{
					text: 'Тариф',
					value: 'tariff',
					align: 'center',
					divider: true
				},
				{
					text: 'Date',
					value: 'created_date',
					align: 'center',
					divider: true
				},
				{
					text: 'Расписание Яндекс',
					value: 'yandex_discrip',
					align: 'center',
					divider: true
				},
				{
					text: 'Расписание Google',
					value: 'google_discrip',
					align: 'center',
					divider: true
				},
				{
					text: 'days_count Яндекс',
					value: 'send_days_yandex_cnt',
					align: 'center',
					divider: true
				},
				{
					text: 'days_count Гугл',
					value: 'send_days_google_cnt',
					align: 'center',
					divider: true
				},
				{
					text: 'Регион WS',
					value: 'region_ws',
					align: 'center',
					divider: true
				},
				{
					text: 'Регион serp',
					value: 'region_serp',
					align: 'center',
					divider: true
				},
				{
					text: 'min_queries',
					value: 'min_semantic_cnt',
					align: 'center',
					divider: true
				},
				{
					text: 'avg_queries',
					value: 'avg_semantic_cnt',
					align: 'center',
					divider: true
				},
				{
					text: 'max_queries',
					value: 'max_semantic_cnt',
					align: 'center',
					divider: true
				},
				{
					text: 'queries_last_day',
					value: 'last_day_semantic_cnt',
					align: 'center',
					divider: true
				},
				{
					text: 'data-unit -send',
					value: 'send_all_data',
					align: 'center',
					divider: true
				},
				{
					text: 'ws-unit - send',
					value: 'send_ws_data',
					align: 'center',
					divider: true
				},
				{
					text: 'ws -unit google -send',
					value: 'send_ws_google_cnt',
					align: 'center',
					divider: true
				},
				{
					text: 'ws -unit yandex -send',
					value: 'send_ws_yandex_cnt',
					align: 'center',
					divider: true
				},
				{
					text: 'serp-unit - send',
					value: 'send_serp_data',
					align: 'center',
					divider: true
				},
				{
					text: 'serp-unit google - send',
					value: 'send_serp_google_cnt',
					align: 'center',
					divider: true
				},
				{
					text: 'serp-unit yandex - send',
					value: 'send_serp_yandex_cnt',
					align: 'center',
					divider: true
				},
				{
					text: 'data-unit - receipt',
					value: 'receipt_all_data',
					align: 'center',
					divider: true
				},
				{
					text: 'ws-unit - receipt',
					value: 'receipt_ws_data',
					align: 'center',
					divider: true
				},
				{
					text: 'ws -unit google - receipt',
					value: 'receipt_ws_google_cnt',
					align: 'center',
					divider: true
				},
				{
					text: 'ws -unit yandex -receipt',
					value: 'receipt_ws_yandex_cnt',
					align: 'center',
					divider: true
				},
				{
					text: 'serp-unit- receipt',
					value: 'receipt_serp_data',
					align: 'center',
					divider: true
				},
				{
					text: 'serp-unit google - receipt',
					value: 'receipt_serp_google_cnt',
					align: 'center',
					divider: true
				},
				{
					text: 'serp-unit yandex - receipt',
					value: 'receipt_serp_yandex_cnt',
					align: 'center',
					divider: true
				}
			],
			loading: {
				table: true,
				clients: true
			}
		}
	},

	computed: {
		...mapState({
			projectsStatisticsData: state => state.projectsStatistics.projectsStatisticsData?.items || [],
			clients: state => state.clients
		}),

		tableItems () {
			return this.projectsStatisticsData.map(item => {
				return {
					...item,
					project_id: item.project_id,
					project_description: item.project_description,
					tariff: item.tariff,
					creation_date: item.creation_date,
					yandex_discrip: item.yandex_discrip,
					google_discrip: item.google_discrip,
					send_days_yandex_cnt: item.send_days_yandex_cnt,
					send_days_google_cnt: item.send_days_google_cnt,
					region_ws: item.region_ws,
					region_serp: item.region_serp,
					min_semantic_cnt: item.min_semantic_cnt,
					max_semantic_cnt: item.max_semantic_cnt,
					avg_semantic_cnt: item.avg_semantic_cnt,
					last_day_semantic_cnt: item.last_day_semantic_cnt,
					send_all_data: item.send_all_data,
					send_ws_data: item.send_ws_data,
					send_ws_yandex_cnt: item.send_ws_yandex_cnt,
					send_ws_google_cnt: item.send_ws_google_cnt,
					send_serp_data: item.send_serp_data,
					send_serp_yandex_cnt: item.send_serp_yandex_cnt,
					send_serp_google_cnt: item.send_serp_google_cnt,
					receipt_all_data: item.send_all_data,
					receipt_ws_data: item.receipt_ws_data,
					receipt_ws_yandex_cnt: item.receipt_ws_yandex_cnt,
					receipt_ws_google_cnt: item.receipt_ws_google_cnt,
					receipt_serp_data: item.receipt_serp_data,
					receipt_serp_yandex_cnt: item.receipt_serp_yandex_cnt,
					receipt_serp_google_cnt: item.receipt_serp_google_cnt
				}
			})
		},

		urlFilters () {
			const {
				client_ids,
				tariff_id,
				date_from,
				date_to,
				only_active_projects
			} = this.$route.query

			return {
				client_ids: validateFilterFromOptions(Array.isArray(client_ids) ? client_ids : [client_ids], this.clients, [], true, true),
				tariff_id: tariff_id ? Number(tariff_id) : null,
				date_from: date_from,
				date_to: date_to,
				only_active_projects: only_active_projects
			}
		}
	},

	async created () {
		try {
			await this.getClients()
		} catch (_) {
			this.$notify({
				type: NOTIFY_STATUS.ERROR,
				title: errors.GET_DATA
			})
		} finally {
			this.loading.clients = false
		}
		await this.initDataTable()
	},

	watch: {
		async '$route.query' () {
			await this.initDataTable()
		}
	},

	methods: {
		...mapActions({
			getProjectsStatisticsData: 'projectsStatistics/getProjectsStatisticsData',
			getClients: 'getClients'
		}),

		async initDataTable () {
			const {
				client_ids,
				tariff_id,
				date_from,
				date_to,
				only_active_projects
			} = this.urlFilters

			this.loading.table = true
			await this.getProjectsStatisticsData({
				query: {
					client_ids: client_ids,
					tariff_id: tariff_id || undefined,
					date_from: date_from || undefined,
					date_to: date_to || undefined,
					only_active_projects: only_active_projects ?? 1
				}
			})
			this.loading.table = false
		},

		downloadCsv () {
			const url = new URL('bridge/seowork/projects/statistics', this.$store.state.config.api.hqsw)

			const {
				client_ids,
				date_from,
				date_to,
				tariff_id,
				only_active_projects
			} = this.urlFilters

			const params = new URLSearchParams()

			;(client_ids ?? []).forEach((id, index) => {
				params.append(`client_ids[${index}]`, id)
			})

			date_from && params.append('date_from', date_from)
			date_to && params.append('date_to', date_to)
			tariff_id && params.append('tariff_id', tariff_id)
			params.append('only_active_projects', only_active_projects ?? 1)

			params.append('download', 1)
			params.append('format', 'CSVWithNames')

			url.search = params.toString()

			const link = document.createElement('a')
			link.href = url.toString()

			document.body.appendChild(link)
			link.click()
			link.remove()
		},

		formatFloat (value) {
			if (value == null) return null
			return Number(value)
				.toFixed(2)
				.replace(/\.?0+$/, '')
		}
	}
}
</script>

<style >
.clients-statistics-table {
	margin-top: 24px;
	border-top: 1px solid rgba(0,0,0,.12);
}
</style>
